module.exports = __webpack_public_path__ + "img/duplicate.97ff0f2c.svg";